import React from "react";
import PropTypes from "prop-types";
import ContentPageSharePublicLinksSocial from "./ContentPageSharePublicLinksSocial";

const ContentPageShareableQuote = (props) => {
	const { hideShare, quoteText, showQuotationMarks, theme, shareUrl, guid, sharePlatforms } =
		props.dataset;
	const platforms = JSON.parse(sharePlatforms).map((platform) => ({ label: platform }));
	const quote =
		showQuotationMarks === "true" || showQuotationMarks === true
			? "\u201C" + quoteText + "\u201D"
			: quoteText;
	const analytics = {
		action: "Share Quote_" + guid,
		category: "Share",
		comp: "Share Quote"
	};

	return (
		<div className={`content-page-shareable-quote ${theme}`}>
			<div className="eyebrow"></div>
			<div className="content-page-shareable-quote-text">{quote}</div>
			{hideShare === "false" || hideShare === false ? (
				<div className="pdf--ignore">
					<ContentPageSharePublicLinksSocial
						analytics={analytics}
						shareUrl={shareUrl}
						data={platforms}
						quoteText={quote}
					/>
				</div>
			) : null}
		</div>
	);
};

ContentPageShareableQuote.propTypes = {
	dataset: PropTypes.shape({
		guid: PropTypes.string.isRequired,
		quoteText: PropTypes.string,
		showQuotationMarks: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
		hideShare: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.bool.isRequired]),
		shareUrl: PropTypes.string,
		theme: PropTypes.string.isRequired,
		sharePlatforms: PropTypes.string.isRequired
	})
};

ContentPageShareableQuote.defaultProps = {
	dataset: {
		guid: "ABCDE01234",
		quoteText:
			"The future is always uncertain. But willingness to bear uncertainty is the key reason investors have the opportunity for profit.",
		showQuotationMarks: "true",
		hideShare: "false",
		shareUrl: "https://www.dimensional.com",
		theme: "content-page-shareable-quote-theme-default",
		sharePlatforms: '["facebook", "twitter", "linkedin"]'
	}
};
export default ContentPageShareableQuote;
